import { useEffect, useState } from "react";
import { useTranslation } from "@/hooks/useSafeTranslation";
import { Link, useNavigate } from "@tanstack/react-router";
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { exchangeCodeForSession } from "@/auth";
import { hasSupabaseConfig } from "@/config";
import { toErrorDisplayMessage, toDisplayString, toSafeReactNode } from "@/lib/utils";

function AuthCallbackPage() {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!hasSupabaseConfig()) {
      setError(toDisplayString(t("authCallback.configError")));
      return;
    }
    let cancelled = false;
    exchangeCodeForSession().then((res) => {
      if (cancelled) return;
      if (res.error) {
        setError(toErrorDisplayMessage(res.error));
        return;
      }
      navigate({ to: "/", replace: true });
    });
    return () => {
      cancelled = true;
    };
  }, [navigate, t]);

  if (error) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-bg p-4">
        <p className="text-center text-sm text-danger">{toErrorDisplayMessage(error)}</p>
        <Link
          to="/login"
          className="rounded-lg border border-border bg-surface-2 px-4 py-2 text-sm font-medium text-text hover:bg-surface"
        >
          {toSafeReactNode(t("authCallback.backToLogin"))}
        </Link>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg">
      <p className="text-sm text-text-muted">{toSafeReactNode(t("authCallback.completing"))}</p>
    </div>
  );
}

export const authCallbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/auth/callback",
  component: AuthCallbackPage,
});
